import { useParams } from 'react-router-dom';

export function useMatchAid() {
  const { aid, sid } = useParams<{
    aid: string;
    sid: string;
  }>();

  return {
    aid,
    encodedAid: aid ? encodeURIComponent(aid!) : '',
    hasAid: !!aid,
    hasSid: !!sid,
  };
}
